import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, dataActions } from 'reducers';
import Draggable from 'react-draggable';
import './Order.scss';
import { Modal, Table, Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import Spinner from 'components/Spinner';
import { useMediaQuery } from 'react-responsive';
import { LG } from 'lib/util';

const OrderStatus = () => {
    const dispatch = useDispatch();

    const isDesktop = useMediaQuery({ minWidth: LG });

    const orderStatus = useSelector((state: AppState) => state.data.orders.orderStatusInfo.orderStatus);
    const showOrderStatus = useSelector((state: AppState) => state.data.orders.orderStatusInfo.show);
    const isFetching = useSelector((state: AppState) => state.data.orders.props.isOrderStatusFetching);

    const [maxQuantity, setMaxQuantity] = useState(0);
    const [maxWeight, setMaxWeight] = useState(0);

    const closePopup = () => {
        dispatch(dataActions.setShowOrderStatus(false));
    };

    const getNumericCellWidth = (val: number) => {
        const d = document.createElement('div');
        d.innerHTML = val.toFixed(2);
        d.classList.add('measurer');
        document.querySelector('.App-body')?.appendChild(d);
        return d.getBoundingClientRect().width;
    };

    const quantityWidth = useMemo(() => getNumericCellWidth(maxQuantity), [maxQuantity]);
    const weightWidth = useMemo(() => getNumericCellWidth(maxWeight), [maxWeight]);

    useEffect(() => {
        setMaxQuantity(_.maxBy(orderStatus.lines, (l) => l.quantity)?.quantity ?? 0);
        setMaxWeight(_.maxBy(orderStatus.lines, (l) => l.weight)?.weight ?? 0);
    }, [orderStatus]);

    return isDesktop ? (
        <Draggable>
            <div className='OrderStatusPopup' style={showOrderStatus ? {} : { display: 'none' }}>
                <div className='modal-header OrderStatusPopup-header'>
                    <p className='modal-title'>
                        Status realizacji zamówienia: {orderStatus.header.orderNumber}
                    </p>
                    <button type='button' className='close' onClick={closePopup}>
                        <span aria-hidden='true'>×</span>
                        <span className='sr-only'>Close</span>
                    </button>
                </div>
                {
                    isFetching ? <Spinner /> : (
                        <div className='OrderStatusPopup-content'>
                            <Row>
                                <Col md={6}>
                                    <Table className='OrderStatus-table' size='sm' borderless striped>
                                        <tbody>
                                            <tr>
                                                <td>Logo</td> <td className='td-right-allign'>{orderStatus.header.logo}</td>
                                            </tr>
                                            <tr>
                                                <td>Nazwa firmy</td> <td className='td-right-allign'>{orderStatus.header.name}</td>
                                            </tr>
                                            <tr>
                                                <td>Data</td> <td className='td-right-allign'>{orderStatus.header.date}</td>
                                            </tr>
                                            <tr>
                                                <td>Numer</td>
                                                <td className='td-right-allign'>{orderStatus.header.orderNumber}</td>
                                            </tr>
                                            <tr>
                                                <td>Domówienie</td> <td className='td-right-allign'>{orderStatus.header.additional ? 'TAK' : 'NIE'}</td>
                                            </tr>
                                            <tr>
                                                <td>Status realizacji</td>
                                                <td className='td-right-allign'>{orderStatus.header.status}</td>
                                            </tr>
                                            <tr>
                                                <td>Handlowiec</td> <td className='td-right-allign'>{orderStatus.header.trader}</td>
                                            </tr>
                                            <tr>
                                                <td>Numery FA</td> <td className='td-right-allign'>{orderStatus.header.FAnumbers}</td>
                                            </tr>
                                            <tr>
                                                <td>Waga</td>
                                                <td className='td-right-allign'>{orderStatus.header.weight}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col
                                    md={6}
                                    style={{
                                        display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
                                    }}
                                >
                                    <Table className='OrderStatus-table' size='sm' borderless striped>
                                        <tbody>
                                            <tr>
                                                <td>Adres dostawy</td> <td className='td-right-allign'>{orderStatus.header.deliveryAddress}</td>
                                            </tr>
                                            <tr>
                                                <td>Numer klienta</td> <td className='td-right-allign'>{orderStatus.header.clientNumber}</td>
                                            </tr>
                                            <tr>
                                                <td>Uwagi</td> <td className='td-right-allign'>{orderStatus.header.remarks}</td>
                                            </tr>
                                            <tr>
                                                <td>Opis</td> <td className='td-right-allign'>{orderStatus.header.description}</td>
                                            </tr>
                                            <tr>
                                                <td>Dekarz</td> <td className='td-right-allign'>{orderStatus.header.roofer}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <Table className='OrderStatus-table' size='sm' borderless striped>
                                        <thead>
                                            <tr>
                                                <th colSpan={2}>Wartość zamówienia</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Netto</td>
                                                <td className='td-right-allign'>{orderStatus.header.net}</td>
                                            </tr>
                                            <tr>
                                                <td>VAT</td>
                                                <td className='td-right-allign'>{orderStatus.header.vat}</td>
                                            </tr>
                                            <tr>
                                                <td>Brutto</td>
                                                <td className='td-right-allign'>{orderStatus.header.gross}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <div>
                                <h3>Pozycje</h3>
                            </div>
                            <Table className='OrderStatus-table' size='sm' borderless striped>
                                <thead>
                                    <tr>
                                        <th className='cell-width-300px'>Nazwa kartoteki</th>
                                        <th className='cell-width-30px'>JM</th>
                                        <th>Status realizacji</th>
                                        <th>Producent</th>
                                        <th className='cell-width-50px'>Ilosc</th>
                                        <th className='cell-width-50px'>Waga</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {_.map(orderStatus.lines, (line, index) => (
                                        <tr key={`${orderStatus.header.orderId}-${index}`}>
                                            <td><div className='cell-width-300px'>{line.catalogueName}</div></td>
                                            <td><div className='cell-width-30px'>{line.unit}</div></td>
                                            <td><div className='td-center-text'>{line.status}</div></td>
                                            <td><div>{line.producer}</div></td>
                                            <td><div className='price-td-div' style={{ width: quantityWidth }}>{line.quantity.toFixed(2)}</div></td>
                                            <td><div className='price-td-div' style={{ width: weightWidth }}>{line.weight.toFixed(2)}</div></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )
                }
            </div>
        </Draggable>
    ) : (
        <Modal show={showOrderStatus} onHide={closePopup}>
            <Modal.Header closeButton style={{ position: 'sticky', top: 0, zIndex: 100 }}>
                <Modal.Title style={{ fontSize: '1rem' }}>
                    <span>
                        Status realizacji zamówienia:
                        <br />
                        {' '}
                        {orderStatus.header.orderNumber}
                    </span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: 0 }}>
                <div className='OrderStatus-body-mobile'>
                    {
                        isFetching ? <Spinner centered={false} /> : _.map(orderStatus.lines, (part, index) => (
                            <div className='OrderStatus-body-mobile-part' key={`${orderStatus.header.orderId}-${index}`}>
                                {/* <h6>{part.kar}</h6> */}
                                <div>
                                    <span>Status:</span>
                                    <hr />
                                    <span>{part.status}</span>
                                </div>
                                {(part.producer.length > 0) && (
                                    <div>
                                        <span>Producent:</span>
                                        <hr />
                                        <span>{part.producer}</span>
                                    </div>
                                )}
                            </div>
                        ))
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default OrderStatus;
